/**
 * @see https://jirr20240624073410550.pingcode.com/pjm/workitems/_VNkhgZ6
 * 内聚淘宝平台发货治理相关逻辑
 * 后续验收通过后，此代码可能会移除掉
 */
import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import moment from "moment";
import { isAnyOrderWithPreSaleTag } from "./OrderTagUtils";
import { isMergeOrder } from "./OrderUtils";
import GlobalStore from "@/store";
import ShopType from "@/enum/ShopType";

/**
 * 判断订单是否是非预售且下单时间在3小时内
 */
function isWithinThreeHours(order: OrderDTO): boolean {
    if (!order.orderTime) return false;
    if (isAnyOrderWithPreSaleTag([order])) return false;
    if (moment(order.orderTime).add(3, "h").isBefore(moment())) return false;
    return true;
}

/**
 * 获取下单时间不到3个小时的非预售订单
 */
export function filterOrdersWithinThreeHours(orders: OrderDTO[], globalStore: typeof GlobalStore) {
    if (!orders) return [];

    return orders.filter((order) => {
        const shop = globalStore.shopMapping.get(order.shopId);
        if (![ShopType.TAOBAO, ShopType.TAOBAO_DISTRIBUTION].includes(shop?.type)) return false;

        if (isMergeOrder(order)) {
            return order.childOrders.some(isWithinThreeHours);
        }

        return isWithinThreeHours(order);
    });
}

function isWithShippingDeadlineOver48Hours(order: OrderDTO) {
    if (!order.shippingDeadline) return false;
    if (!order.tags) return false;
    if (!isAnyOrderWithPreSaleTag([order])) return false;

    const shippingDeadlineMoment = moment(order.shippingDeadline);
    const current = moment();

    // 已超时
    if (shippingDeadlineMoment.isBefore(current)) return false;
    // 小于48小时
    if (current.add(48, "h").isAfter(shippingDeadlineMoment)) return false;

    return true;
}

/**
 * 获取距离最晚发货时间间隔大于48小时的预售订单
 */
export function filterOrdersWithShippingDeadlineOver48Hours(orders: OrderDTO[], globalStore: typeof GlobalStore) {
    if (!orders) return [];

    return orders.filter((order) => {
        const shop = globalStore.shopMapping.get(order.shopId);
        if (![ShopType.TAOBAO, ShopType.TAOBAO_DISTRIBUTION].includes(shop?.type)) return false;

        if (isMergeOrder(order)) {
            return order.childOrders.some(isWithShippingDeadlineOver48Hours);
        }

        return isWithShippingDeadlineOver48Hours(order);
    });
}
